export default function (typyZdroju = []) {
  const zdroje = [];
  typyZdroju.forEach(typZdroje => {
    typZdroje.zdroje.forEach(zdroj => {
      zdroje.push(zdroj.zdroj);
    });
  });
  return zdroje;
}
